import Vue from 'vue';
import Vuex from 'vuex';
import AuthModule from './auth';
import FormModule from './form';
import EnglishModule from './englishform'
import JapaneseModule from './japaneseform'
import GermanModule from './germanform'
import ChineseModule from './chineseform'
import MenuModule from './menu';
import RoleModule from './role';
import UserModule from './user';
import EmployeeModule from './employee';
import ConfigModule from './config';
import CodeDtModule from './codeDt';
import SystemNewsModule from './systemNews';
import {UploadService} from '../services';

Vue.use(Vuex);

export async function bindLoading(commit, action, ns = ''
                                  , options = {delay: 200, exposure: false}) {
    commit({
        type: 'saveLoading',
        loading: true,
        ns,
        exposure: options.exposure
    }, {root: true});

    await new Promise(resolve => {
        setTimeout(() => resolve(true), options.delay)
    });

    const result = await action();

    commit({
        type: 'saveLoading',
        loading: false,
        root: true,
        ns
    }, {root: true});

    return result;
}

export default new Vuex.Store({
    modules: {
        auth: AuthModule,
        form: FormModule,
        englishform: EnglishModule,
        japaneseform: JapaneseModule,
        germanform: GermanModule,
        chineseform: ChineseModule,
        menu: MenuModule,
        role: RoleModule,
        user: UserModule,
        employee: EmployeeModule,
        config: ConfigModule,
        codeDt: CodeDtModule,
        systemNews: SystemNewsModule,
    },
    state: {
        loading: {
            global: false,
            actions: {}
        },
    },
    mutations: {
        saveLoading(current, {loading, ns = '', exposure = false}) {
            current.loading.global = exposure ? loading : false;

            if (ns) {
                if (current.loading.actions.hasOwnProperty(ns)) {
                    current.loading.actions[ns] = loading;
                } else {
                    Vue.set(current.loading.actions, ns, loading);
                }
            }
        },
        resetLoading(current) {
            current.loading.global = false;
            Vue.set(current.loading, 'actions', {});
        }
    },
    actions: {
        async removeFileAction(_, {key, encrypted}) {
            await UploadService.removeFile({key, encrypted});
        },

        async downloadFileAction(_, payload) {
            const url = window.URL.createObjectURL(new Blob([await UploadService.download(payload)]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', payload.fullName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
    }
});